import { logos } from './logos';

export const shareLinks = [
  {
    name: 'gmail',
    label: 'Gmail',
    logo: logos.gmail,
    share: link =>
      `https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&source=mailto&su=SmartGift&body=${link}`
  },
  {
    name: 'linkedin',
    label: 'LinkedIn',
    logo: logos.linkedin,
    share: link => `https://www.linkedin.com/sharing/share-offsite?mini=true&url=${link}`
  },
  {
    name: 'messenger',
    label: 'Messenger',
    logo: logos.messenger,
    share: link => `https://www.facebook.com/sharer/sharer.php?u=${link}`
  },
  {
    name: 'outlook',
    label: 'Outlook',
    logo: logos.outlook,
    share: link =>
      `https://outlook.live.com/owa/?path=/mail/action/compose&to=&subject=SmartGift&body=${link}`
  },
  {
    name: 'telegram',
    label: 'Telegram',
    logo: logos.telegram,
    share: link => `https://t.me/share/url?url=${link}`
  },
  {
    name: 'whatsapp',
    label: 'WhatsApp',
    logo: logos.whatsapp,
    share: link => `https://wa.me/?text=${link}`
  }
];
